export default {
  // 查询会员信息_李详达
  memberGetMemberInfo(params) {
    return app.http.ajax({
      method: 'get',
      url: '/member-portal/shop/getMemberInfo',
      params: params,
    });
  },
  // 查询首页任务接口_李详达
  memberQueryH5HomePage(params) {
    return app.http.ajax({
      method: 'get',
      url: '/member-portal/shop/queryH5HomePage',
      params: params,
    });
  },
  // 家长端会员权益列表_李祥达
  queryH5EntitlementList(params) {
    return app.http.ajax({
      method: 'get',
      url: '/member-portal/shop/queryH5EntitlementList',
      params: params,
    });
  },
  // 家长端获取会员(学员)积分明细_李祥达
  pageH5PointEntry(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/member-portal/shop/pageH5PointEntry',
      params: params,
    });
  },
  // 家长会员积分签到_李祥达
  memberSignInH5(params) {
    return app.http.ajax({
      method: 'get',
      url: '/member-portal/shop/signInH5',
      params: params,
    });
  },
  // 家长获取学员详情（含人脸版）_李祥达
  memberGetContainFace(params) {
    return app.http.ajax({
      method: 'get',
      url: '/member-portal/shop/getContainFace',
      params: params,
    });
  },
  // 家长获取学员详情（含人脸版）_李祥达
  getMemberCustomFieldList(params) {
    return app.http.ajax({
      method: 'get',
      url: '/member-portal/shop/getMemberInfo/customField/list',
      params: params,
    });
  },
  // 家长获取学员详情（含人脸版）_李祥达
  updateMemberInfo(params) {
    return app.http.ajax({
      method: 'post',
      url: '/member-portal/shop/updateMemberInfo',
      params: params,
    });
  },
  // 活动列表_李祥达
  pageMemberActivity(params) {
    return app.http.ajax({
      method: 'post',
      url: '/member-portal/shop/pageMemberActivity',
      params: params,
    });
  },
  // 家长端获取会员活动详情_李祥达
  getMemberActivityById(params) {
    return app.http.ajax({
      method: 'get',
      url: '/member-portal/shop/getMemberActivityById',
      params: params,
    });
  },
};
